export default {
  formTitle: 'Зв\'язатися з нами',
  submit: 'Відправити',
  mail: 'E-mail',
  name: 'Ім\'я',
  comment: 'Повідомлення',
  sendText: 'Дякую за ваше звернення!',
  toForm: 'Назад'
}


// WEBPACK FOOTER //
// ./src/locale/uk-UA/contactUs.js